import React from 'react'
import { FaqsWrapper } from './Styled'
import { useTranslation } from 'react-i18next'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, MainHeading } from '../../../ui/Elements'
import QuestionCard from './Questions'



const Faqs = () => {
    const { t, i18n } = useTranslation();
    
    return (
        <FaqsWrapper id='faqs' className='secFaqs common-space faqsWrapper'>
            <Container fluid className='faqsBg'>
                <Container>
                    <Row>
                        <Col md={12} className='faqsContentWrap'>
                            <Box className='faqsHeadings'>
                                <MainHeading className='main-heading main-heading-sub' size="32px" color="var(--secondaryColor)">
                                    {t('FAQs2')}
                                </MainHeading>
                                <MainHeading className='main-heading mb-4'>
                                    {t('YourQuestionsAnswered')}
                                </MainHeading>
                            </Box>
                        </Col>
                        
                    </Row>
                    <Row>
                        <Col md={12} className='faqsQAWrap'>
                            <QuestionCard />
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Box className='stripe stripe1'></Box>
                
        </FaqsWrapper>
    )
}

export default Faqs